export const inviteCopyEn = {
  title: "You're invited",
  titleWithInviter: (name: string) => `${name} invited you to WandererTrip`,
  lead: 'This link opens in the WandererTrip app or on the web. Continue below to accept.',
  qrLead: 'Scan complete. Download WandererTrip to open this invite in the app.',
  leadWithInviter: (name: string) =>
    `${name} invited you to connect on WandererTrip. Continue on the web or download the app to accept.`,
  cta: 'Download on the App Store',
  continueOnWeb: 'Continue on web',
  notOnIos:
    'On iPhone, open this link to install or open the app. On desktop, continue on the web below.',
  loading: 'Loading your invite…',
  expired: 'This invite has expired. Ask the sender for a new link.',
  notFound: 'This invite link is invalid or has already been used.',
  fetchError: 'We could not load invite details. You can still continue below.',

  acceptLoading: 'Accepting your invite…',
  acceptSuccess: 'Invite accepted',
  acceptAlreadyAccepted: 'This invite was already accepted.',
  acceptFailed: 'Could not accept this invite. Try again or ask for a new link.',
  acceptMissingEmail: 'Your account needs an email address to accept this invite.',
  acceptBackToInvite: 'Back to invite',
  acceptGoToTrips: 'Go to trips',
  acceptRetry: 'Try again',
} as const;
